import type { CSSProperties } from 'react'

export type ChatCornerStyle = 'rounded' | 'square'
export const ChatCornerStyle = { ROUNDED: 'rounded', SQUARE: 'square' } as const

export type ChatColorMode = 'light' | 'dark'
export const ChatColorMode = { LIGHT: 'light', DARK: 'dark' } as const

export const CHAT_CORNER_STYLE_STORAGE_KEY = 'ai-chat-corner-style'
export const CHAT_COLOR_MODE_STORAGE_KEY = 'ai-chat-color-mode'

interface ReadableStorage {
  getItem(key: string): string | null
}

export const readChatCornerStyle = (storage?: ReadableStorage): ChatCornerStyle => {
  if (!storage) return ChatCornerStyle.SQUARE

  try {
    const value = storage.getItem(CHAT_CORNER_STYLE_STORAGE_KEY)
    if (value === null) return ChatCornerStyle.SQUARE
    const parsed = JSON.parse(value)
    return parsed === ChatCornerStyle.ROUNDED || parsed === ChatCornerStyle.SQUARE
      ? parsed
      : ChatCornerStyle.SQUARE
  } catch {
    return ChatCornerStyle.SQUARE
  }
}

export const readBrowserChatCornerStyle = (): ChatCornerStyle => {
  try {
    return readChatCornerStyle(typeof window === 'undefined' ? undefined : window.localStorage)
  } catch {
    return ChatCornerStyle.SQUARE
  }
}

export const readChatColorMode = (storage?: ReadableStorage): ChatColorMode => {
  if (!storage) return ChatColorMode.LIGHT

  try {
    const value = storage.getItem(CHAT_COLOR_MODE_STORAGE_KEY)
    if (value === null) return ChatColorMode.LIGHT
    const parsed = JSON.parse(value)
    return parsed === ChatColorMode.DARK || parsed === ChatColorMode.LIGHT
      ? parsed
      : ChatColorMode.LIGHT
  } catch {
    return ChatColorMode.LIGHT
  }
}

export const readBrowserChatColorMode = (): ChatColorMode => {
  try {
    return readChatColorMode(typeof window === 'undefined' ? undefined : window.localStorage)
  } catch {
    return ChatColorMode.LIGHT
  }
}

export const getChatCornerVariables = (cornerStyle: ChatCornerStyle): CSSProperties => {
  const square = cornerStyle === ChatCornerStyle.SQUARE

  return {
    '--ai-chat-radius-shell': square ? '5px' : '24px',
    '--ai-chat-radius-card': square ? '5px' : '20px',
    '--ai-chat-radius-control': square ? '5px' : '18px',
    '--ai-chat-radius-message': square ? '5px' : '30px',
  } as CSSProperties
}
